if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
      if (typeof resumeMetaGalleryVideos === 'function') resumeMetaGalleryVideos();
    }

    show(opener) {
      /* 2026-09-02: hydrate deferred modal images (product-media.liquid emits data-src/data-srcset/data-sizes
         so a closed modal never downloads the full-size gallery). Active media first, then the rest. */
      var self = this, want = opener && opener.getAttribute('data-media-id');
      var imgs = Array.prototype.slice.call(this.querySelectorAll('img[data-src],img[data-srcset]'));
      imgs.sort(function (a, b) {
        var am = a.closest('[data-media-id]'), bm = b.closest('[data-media-id]');
        return (bm && bm.getAttribute('data-media-id') === want) - (am && am.getAttribute('data-media-id') === want);
      });
      imgs.forEach(function (img) {
        if (img.dataset.sizes) { img.sizes = img.dataset.sizes; delete img.dataset.sizes; }
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
        if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
      });
      window.__ciHydrateModalImages = imgs.length;
      super.show(opener);
      this.showActiveMedia();
      if (typeof resumeMetaGalleryVideos === 'function') resumeMetaGalleryVideos();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
